module.exports = __webpack_public_path__ + "img/Eric.785c04b7.png";